import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { Grid, Segment } from 'semantic-ui-react'
import VideoPlayer from 'Components/VideoPlayer/VideoPlayer'
import CommentsList from 'Components/Comments/List'
import VideoActions from 'Redux/VideoRedux'
import styles from './ReviewStyles'

class Review extends Component {
  static propTypes = {
    videoId: PropTypes.number.isRequired,
    history: PropTypes.object.isRequired
  }

  componentDidMount () {
    this.fetchVideoVersions()
  }

  componentDidUpdate (prevProps) {
    if (this.props.videoId !== prevProps.videoId) {
      this.fetchVideoVersions()
    }
    if (this.props.videoVersions !== prevProps.videoVersions) {
      this.props.videosSetCurrent(this.props.videoId)
    }
  }

  fetchVideoVersions = () => {
    this.props.videosVersionsRequest(this.props.videoId)
  }

  onVersionChange = (value) => {
    this.props.history.push('/videos/' + value)
  }

  render () {
    if (!this.props.currentVideo) return null
    return (
      <Grid stackable columns={2} padded className={styles.wrapper}>
        <Grid.Column width={11}>
          <VideoPlayer
            onVersionChange={this.onVersionChange}
          />
          {this.props.currentVideo.description &&
            <Segment>
              <h3>Description</h3>
              <p>{this.props.currentVideo.description}</p>
            </Segment>
          }
        </Grid.Column>
        <Grid.Column width={5}>
          <CommentsList
            videoId={this.props.videoId}
          />
        </Grid.Column>
      </Grid>
    )
  }
}

const mapStateToProps = (state) => ({
  videoVersions: state.videos.versionsData,
  currentVideo: state.videos.currentVideo
})

const mapDispatchToProps = (dispatch) => ({
  videosVersionsRequest: videoId =>
    dispatch(VideoActions.videosVersionsRequest(videoId)),
  videosSetCurrent: videoId =>
    dispatch(VideoActions.videosSetCurrent(videoId))
})

export default connect(mapStateToProps, mapDispatchToProps)(Review)



// WEBPACK FOOTER //
// ./src/Components/Review.js